// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface SuccessStoriesCardProps {
	featured: boolean
	href: {
		url: string
		isExternal?: boolean
	}
	img?: {
		src: string
		srcSmall?: string
		alt?: string
	}
	subtitle?: string
	title: string
}

export default function SuccessStoriesCard({
	featured,
	href,
	img,
	subtitle,
	title
}: SuccessStoriesCardProps) {
	return (
		featured ? (
			<a
				href={href?.url}
				target={href?.isExternal ? '_blank' : undefined}
				className={clsx(
					'success-stories-card-featured',
					!img?.src && 'success-stories-card-featured--no-image'
				)}
			>
				<div className='grid-row'>

					<div className='c-md-8 success-stories-card-featured__left'>
						<div className='success-stories-card-featured__left__image'>
							{img?.src && (
								<Image
									srcSmall={[`${img.srcSmall}`, 574]} // 450x450
									src={img.src} // 900x500
									alt={img.alt}
									className='cover'
								/>
							)}
						</div>
					</div>

					<div className='c-md-4 success-stories-card-featured__right'>
						<div className='success-stories-card-featured__content'>

							{isNonWhitespaceString(subtitle) && (
								<p className='success-stories-card-featured__subtitle'>
									{subtitle}
								</p>
							)}

							{isNonWhitespaceString(title) && (
								<p className='success-stories-card-featured__title'>
									{title}
								</p>	
							)}

						</div>
					</div>

				</div>
			</a>
		) : (
			<a
				href={href?.url}
				target={href?.isExternal ? '_blank' : undefined}
				className={clsx(
					'success-stories-card',
					!img?.src && 'success-stories-card--no-image'
				)}
			>
				<div className='success-stories-card__image'>
					{img?.src && (
						<Image
							src={img.src} // 450x300
							alt={img.alt || title}
							className='cover'
						/>
					)}
				</div>

				<div className='success-stories-card__content'>

					{isNonWhitespaceString(subtitle) && (
						<p className='success-stories-card__subtitle'>
							{subtitle}
						</p>
					)}

					{isNonWhitespaceString(title) && (
						<p className='success-stories-card__title'>
							{title}
						</p>	
					)}

				</div>

			</a>
		)
	)
}